import {
  BadGateway,
  BadRequestError,
  Conflict,
  Forbidden,
  NotFound,
  UnexpectedError,
} from 'domain/errors';
import { CreateSacConfig } from 'domain/usecases/sacConfig/remote';

import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteCreateSacConfig implements CreateSacConfig {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateSacConfig.Model>;

  constructor(url: string, httClient: HttpClient<CreateSacConfig.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateSacConfig.Params,
  ): Promise<CreateSacConfig.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.orgId}/CONFIG`,
      method: 'post',
      body: params.body,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      case HttpStatusCode.conflict:
        throw new Conflict();
      default:
        throw new UnexpectedError();
    }
  };
}
